export const tempAction = (param) => {
  return (dispatch) => {
    dispatch({ type: "SET_TEMPDATA", data: param });
  }
};

export const acceptAction = (param) => {
  return (dispatch) => {
    dispatch({ type: "SET_ACCEPT", data: param });
  }
};
export const textAction = (param) => {
  return (dispatch) => {
    dispatch({ type: "SET_TEXT", data: param });
  }
};

export const tagAction = (param) => {
  return (dispatch) => {
    dispatch({ type: "SET_TAG", data: param });
  }
};
export const validationDataAction = (param) => {
  return (dispatch) => {
    dispatch({ type: "SET_VALIDATION_TEXT", data: param });
  }
};


export const validationAction = (param) => {
  return (dispatch) => {
    dispatch({ type: "SET_VALIDATION", data: param });
  }
};


export const resetAutoSaveData = () => {

  return (dispatch) => {
    dispatch({ type: "SET_AUTOSAVE_DATA", data: [] });
  }
};
